import { useState, useEffect, useRef, useCallback } from 'react';
import { loadScript, RDB_CLIENT_ID } from '@web-common/utils/utils';
import { apiHolder } from 'api';
import { WaActions } from '@web-common/state/reducer';
import { useActions } from '@web-common/state/createStore';
const systemApi = apiHolder.api.getSystemApi();
const GLOBAL_LX_REMOTE_DEBUG = '__LX__SNP__GLOBAL_REMOTE_DEBUG__';
const REMOTE_DEBUG_URL = 'https://lingxi.office.163.com/rdbstatic/prodinject.v1.0.0.js';
const channel = typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel(GLOBAL_LX_REMOTE_DEBUG) : undefined;
export default function useRemoteDebugTools() {
    const [debugToolsVisible, setDebugToolsVisible] = useState(false);
    const [remoteVisible, setRemoteVisible] = useState(false);
    const unsubscribeRcStatus = useRef(null);
    const unsubscribeRmStatus = useRef(null);
    const waActions = useActions(WaActions);
    useEffect(() => {
        const tools = window[GLOBAL_LX_REMOTE_DEBUG];
        if (tools) {
            setDebugToolsVisible(tools.status === 'record');
            setRemoteVisible(tools.status === 'remote');
            unsubscribeRmStatus.current = tools.on('statusChange', status => {
                setRemoteVisible(status === 'remote');
            });
            unsubscribeRcStatus.current = tools.on('statusChange', status => {
                setDebugToolsVisible(status === 'record');
            });
        }
    }, []);
    const loadDebugTools = useCallback(async () => {
        var _a;
        try {
            await loadScript(REMOTE_DEBUG_URL);
            const tools = window[GLOBAL_LX_REMOTE_DEBUG];
            if (tools) {
                tools.single('uiRecordStart', () => {
                    channel === null || channel === void 0 ? void 0 : channel.postMessage({
                        clientId: RDB_CLIENT_ID,
                        type: 'startRecord',
                        payload: {},
                    });
                    waActions.updateWaimaoToWaToolStatus({ status: 'uiRecordStart' });
                });
                tools.single('uiCancelUpload', () => {
                    channel === null || channel === void 0 ? void 0 : channel.postMessage({
                        clientId: RDB_CLIENT_ID,
                        type: 'stopRecord',
                        payload: {},
                    });
                    waActions.updateWaimaoToWaToolStatus({ status: 'uiCancelUpload' });
                });
                tools.single('uiConfirmUpload', () => {
                    console.log('uiConfirmUpload1');
                    channel === null || channel === void 0 ? void 0 : channel.postMessage({
                        clientId: RDB_CLIENT_ID,
                        type: 'stopRecordAndUpdate',
                        payload: {
                            taskId: RDB_CLIENT_ID,
                        },
                    });
                    waActions.updateWaimaoToWaToolStatus({ status: 'uiConfirmUpload' });
                });
                tools.single('uiClose', () => {
                    channel === null || channel === void 0 ? void 0 : channel.postMessage({
                        clientId: RDB_CLIENT_ID,
                        type: 'closeTools',
                        payload: {},
                    });
                    waActions.updateWaimaoToWaToolStatus({ status: 'uiClose' });
                });
                tools.setConfig({
                    project: process.env.BUILD_ISEDM ? '外贸通' : '灵犀办公',
                    user: (_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id,
                    env: location.host + `[${RDB_CLIENT_ID}]`,
                });
            }
            return tools;
        }
        catch (e) {
            console.log(e, '快照工具加载失败');
            return null;
        }
    }, []);
    const handleSnapshotClick = useCallback(async () => {
        var _a;
        console.log('xxxxx-handleSnapshotClick', { debugToolsVisible });
        if (debugToolsVisible) {
            const tools = window[GLOBAL_LX_REMOTE_DEBUG];
            tools === null || tools === void 0 ? void 0 : tools.closeRecordingTools();
            channel === null || channel === void 0 ? void 0 : channel.postMessage({
                clientId: RDB_CLIENT_ID,
                type: 'closeTools',
                payload: {},
            });
            waActions.updateWaimaoToWaToolStatus({ status: 'closeTools' });
        }
        else {
            channel === null || channel === void 0 ? void 0 : channel.postMessage({
                clientId: RDB_CLIENT_ID,
                type: 'showRecord',
                payload: {
                    config: {
                        project: process.env.BUILD_ISEDM ? '外贸通' : '灵犀办公',
                        user: (_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id,
                        env: location.host,
                    },
                },
            });
            waActions.updateWaimaoToWaToolStatus({ status: 'showRecord' });
            const tools = await loadDebugTools();
            if (tools) {
                tools.displayRecordingTools();
                if (unsubscribeRcStatus.current) {
                    unsubscribeRcStatus.current();
                    unsubscribeRcStatus.current = null;
                }
                unsubscribeRcStatus.current = tools.on('statusChange', status => {
                    setDebugToolsVisible(status === 'record');
                });
            }
        }
    }, [debugToolsVisible]);
    const handleRemoteClick = useCallback(async () => {
        if (remoteVisible) {
            const tools = window[GLOBAL_LX_REMOTE_DEBUG];
            tools === null || tools === void 0 ? void 0 : tools.closeRemoteDebug();
            channel === null || channel === void 0 ? void 0 : channel.postMessage({
                clientId: RDB_CLIENT_ID,
                type: 'stopRemote',
                payload: {},
            });
        }
        else {
            const tools = await loadDebugTools();
            if (tools) {
                await tools.authDisplayRemoteDebugTools();
                if (unsubscribeRmStatus.current) {
                    unsubscribeRmStatus.current();
                    unsubscribeRmStatus.current = null;
                }
                unsubscribeRmStatus.current = tools.on('statusChange', status => {
                    setRemoteVisible(status === 'remote');
                });
            }
        }
    }, [remoteVisible]);
    useEffect(() => {
        return () => {
            if (unsubscribeRcStatus.current) {
                unsubscribeRcStatus.current();
            }
            if (unsubscribeRmStatus.current) {
                unsubscribeRmStatus.current();
            }
        };
    }, []);
    return {
        debugToolsVisible,
        remoteVisible,
        handleSnapshotClick,
        handleRemoteClick,
    };
}
